"use strict";

import React from "react";
import TeamFormScreen from "./TeamFormScreen";

const TeamEditScreen = () => {
    return <TeamFormScreen mode="edit" />;
};

export default TeamEditScreen;
